export const PLAYER_REQUEST = 'PLAYER_REQUEST';
export const PLAYER_SUCCESS = 'PLAYER_SUCCESS';
export const PLAYER_REPORT_REQUEST = 'PLAYER_REPORT_REQUEST';
export const PLAYER_REPORT_REQUEST_SUCCESS = 'PLAYER_REPORT_REQUEST_SUCCESS';
export const PLAYER_REPORT_REQUEST_ERROR = 'PLAYER_REPORT_REQUEST_ERROR';
export const PLAYER_STATS_REQUEST = 'PLAYER_STATS_REQUEST';
export const PLAYER_STATS_REQUEST_SUCCESS = 'PLAYER_STATS_REQUEST_SUCCESS';
export const PLAYER_STATS_REQUEST_ERROR = 'PLAYER_STATS_REQUEST_ERROR';
